import { put, call, takeLatest } from 'redux-saga/effects'

import { UNIT_NO_PARAM } from 'Constants'
import {
  createTag as createUnitNoApi,
  deleteTag as deleteUnitNoApi,
  getTags as getUnitNumbersApi,
} from 'Service/Api'

import * as UnitNoTypes from 'Redux/Types/UnitNoTypes'
import * as UnitNoActions from 'Redux/Actions/UnitNoActions'

function* deleteUnitNo({ payload }) {
  try {
    yield call(deleteUnitNoApi, payload)
    yield put(UnitNoActions.deleteUnitNoSucceeded(payload))
  } catch (errors) {
    yield put(UnitNoActions.deleteUnitNoFailed(errors))
  }
}

function* getUnitNumbers() {
  try {
    const { data } = yield call(getUnitNumbersApi, UNIT_NO_PARAM)
    yield put(UnitNoActions.getUnitNumbersSucceeded(data))
  } catch (errors) {
    yield put(UnitNoActions.getUnitNumbersFailed(errors))
  }
}

function* createUnitNo({ payload }) {
  const { searchTerm, resolve, reject } = payload
  const params = {
    value: searchTerm,
    type: { name: UNIT_NO_PARAM },
  }
  try {
    const { data } = yield call(createUnitNoApi, params)
    yield put(UnitNoActions.addUnitNoSucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(UnitNoActions.addUnitNoFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

export default function* ExpenseCategorySaga() {
  yield takeLatest(UnitNoTypes.DELETE_UNIT_NO, deleteUnitNo)
  yield takeLatest(UnitNoTypes.GET_UNIT_NUMBERS, getUnitNumbers)
  yield takeLatest(UnitNoTypes.ADD_UNIT_NO, createUnitNo)
}
